import Plan from '../../classes/plan';
import planObservable from '../../api/plans/observable';
import { IPlanRequestData } from '../../types/interfaces/plan';
import { Observer } from 'rxjs';
import { setAnonymous, setPlans } from '../../store/slices/plans.slice';
import { store } from '../../store/store';

function initPlans(cb: () => void) {
  const planObserver: Observer<IPlanRequestData[]> = {
    next: (val: IPlanRequestData[]) => {
      let anonymous: Plan | undefined = undefined;
      const plans = val.map((item) => {
        const plan = new Plan(item);
        if (!anonymous && plan.anonymous) {
          anonymous = plan;
        }
        return plan;
      });
      if (anonymous) {
        store.dispatch(setAnonymous(anonymous));
      }
      store.dispatch(setPlans(plans));
    },
    error: () => {
      console.error('Error recovering plans');
      cb();
    },
    complete: () => {
      cb();
      return null;
    },
  };
  planObservable.subscribe(planObserver as Partial<Observer<unknown>>);
}

export default initPlans;
